module.exports = __webpack_public_path__ + "f4ca135d0d299ed58fc65858fd5643f4.mp3";


//////////////////
// WEBPACK FOOTER
// ./static/audios/2000_r_20.mp3
// module id = 421
// module chunks = 0